import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { i18n } from '../../services/i18n';
import { commonActions } from '../common/common';

export const rtkQueryErrorMiddleware: Middleware =
  (api: MiddlewareAPI) => (next) => (action: any) => {
    const dispatch = api.dispatch;
    const { setToast } = commonActions;

    if (isRejectedWithValue(action)) {
      const endpoint = action.meta.arg.endpointName;

      if (action.payload.status === 401) {
        return next(action);
      }

      const type: any = 'error';

      if (action.payload.status === 'FETCH_ERROR') {
        dispatch(setToast({ type, message: i18n.t('ui.toasts.errors.fetchError') }));
      } else if (action.payload.data?.message) {
        dispatch(setToast({ type, message: action.payload.data.message }));
      } else {
        dispatch(setToast({ type, message: i18n.t('ui.toasts.errors.unknownError') }));
      }
    }

    return next(action);
  };
